const statBars = {
  init: function() {
    const observer = new IntersectionObserver(entries => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) {
          return;
        }

        observer.unobserve(entry.target);
        let barPercentagePrimary = entry.target.dataset.barPercentagePrimary;
        let barPercentageSecondary = entry.target.dataset.barPercentageSecondary;

        this.animateBar(
          this.animationEaseTiming,
          progress => {
            // bar width & percent string update
            entry.target.style.setProperty('--bar-percentage-primary', barPercentagePrimary * progress);
            entry.target.style.setProperty('--bar-text-percentage', '"' + Math.round(barPercentagePrimary * progress) + '%"');
            entry.target.style.setProperty('--bar-percentage-secondary', barPercentageSecondary * progress);
          },
          1500
        );

      });

    });

    document.querySelectorAll('.stat-bars-section .bar-block.bar-block-animate')
      .forEach(statBlock => {
        observer.observe(statBlock);
      }
    );
  },
  
  animateBar: function(timing, draw, duration) {
    let start;

    const step = (time) => {
      if (!start) {
        start = time;
      }
      
      // timeFraction goes from 0 to 1
      let timeFraction = (time - start) / duration;
      if (timeFraction > 1) {
        timeFraction = 1;
      }

      // calculate the current animation state
      let progress = timing(timeFraction);
      // draw it
      draw(progress);

      if (timeFraction < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  },

  animationEaseTiming: timeFraction => (Math.sin((timeFraction - .5) * Math.PI) + 1) / 2,
};

document.addEventListener('DOMContentLoaded', function () {
  statBars.init();
});
